import "./NavContainer.css";

export const NavContainer: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    return <div className="nav-container">{children}</div>;
};
